/* eslint-disable */
import PropTypes from 'prop-types';
import { forwardRef, useEffect, useRef, useState, useMemo } from 'react';
import { useDispatch, useSelector } from 'store';

import { Formik, useFormik } from 'formik';
import * as Yup from 'yup';

// material-ui
import { useTheme, styled } from '@mui/material/styles';
import {
    Button,
    FormHelperText,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Grid,
    InputLabel,
    Slide,
    TextField,
    Typography,
    FormControl,
    Select,
    MenuItem,
    InputAdornment,
    List,
    ListItem,
    Input,
    Divider,
    Box
} from '@mui/material';

// project imports
import { gridSpacing, roles } from 'store/constant';
import AnimateButton from 'ui-component/extended/AnimateButton';
import { openSnackbar } from 'store/slices/snackbar';
import { LoadingButton } from '@mui/lab';
import useAuth from 'hooks/useAuth';
import axiosServices from 'utils/axios';
import { EmployeeActions } from 'store/slices/employees';
import useDebounce from 'hooks/useDebounce';
import SearchIcon from '@mui/icons-material/Search';
import { findKeyInObject } from 'utils/findKeyInObjects';

// import { openSnackbar } from 'store/slices/snackbar';

// animation
const Transition = forwardRef((props, ref) => <Slide direction="left" ref={ref} {...props} />);

// ==============================|| PRODUCT ADD DIALOG ||============================== //

const AddManagers = ({ openDialog, handleCloseDialog }) => {
    const dispatch = useDispatch();
    const theme = useTheme();

    const { employee, managers } = useSelector((state) => state.employee);
    const { addApartmentManagers, getMyApartmentManagers, fetchEmployees } = EmployeeActions;
    const [search, setSearch] = useState('');
    const [inviteEmail, setInviteEmail] = useState('');
    const [selectedManager, setSelectedManager] = useState(null);
    const [filteredResults, setFilteredResults] = useState([]);

    const debouncedSearchValue = useDebounce(search, 500);

    const validationSchema = Yup.object().shape({
        email: Yup.string().email('Enter valid email').notRequired()
    });

    const onSubmit = async (values, { setErrors, setStatus, setSubmitting }) => {
        try {
            if (!values?.email) {
                dispatch(
                    openSnackbar({
                        open: true,
                        message: 'Select any manager or invite anyone',
                        variant: 'alert',
                        alert: {
                            color: 'error'
                        },
                        close: true
                    })
                );
                setSubmitting(false);
            } else {
                let response;
                response = await dispatch(addApartmentManagers(values?.email));

                if (response?.payload?.status == 201 || (response?.payload?.status == 200 && response?.payload?.data?.success)) {
                    dispatch(
                        openSnackbar({
                            open: true,
                            message: 'Manager requested successfully.',
                            variant: 'alert',
                            alert: {
                                color: 'success'
                            },
                            close: true
                        })
                    );
                    handleCloseClick();
                    setStatus({ success: true });
                    setSubmitting(false);
                    dispatch(getMyApartmentManagers());
                    window.location.reload();
                } else {
                    //  // console.log(response);
                    dispatch(
                        openSnackbar({
                            open: true,
                            message:
                                findKeyInObject(response?.payload, 'message') ||
                                findKeyInObject(response?.payload, 'errors') ||
                                'Internal server error',
                            variant: 'alert',
                            alert: {
                                color: 'error'
                            },
                            close: true
                        })
                    );
                }
            }
        } catch (err) {
            console.error(err);
            setStatus({ success: false });
            setErrors({ submit: 'Invalid credentials' });
            setSubmitting(false);
        }
    };

    const { values, handleSubmit, handleChange, handleBlur, errors, setFieldValue, touched, isSubmitting } = useFormik({
        onSubmit,
        validationSchema,
        initialValues: { email: '' },
        validateOnBlur: false,
        validateOnChange: false,
        enableReinitialize: true
    });

    const handleCloseClick = () => {
        handleCloseDialog();
    };

    useEffect(() => {
        setFilteredResults(employee.filter((e) => managers?.every((usr) => usr?.apartment_manager_id !== e?.id)));
    }, [employee]);

    useEffect(() => {
        if (search !== '') {
            dispatch(
                fetchEmployees({
                    page: 1,
                    limit: 10000,
                    search,
                    status: 'VERIFIED',
                    emp_type: roles.APARTMENT_MANAGER
                })
            );
        } else {
            setFilteredResults([]);
        }
    }, [debouncedSearchValue]);

    return (
        <Dialog
            open={openDialog}
            TransitionComponent={Transition}
            keepMounted
            onClose={handleCloseDialog}
            sx={{
                '&>div:nth-of-type(3)': {
                    justifyContent: 'flex-end',
                    '&>div': {
                        m: 0,
                        borderRadius: '0px',
                        maxWidth: 400,
                        maxHeight: '100%',
                        height: '100%'
                    }
                }
            }}
        >
            {openDialog && (
                <form onSubmit={handleSubmit} style={{ width: '400px' }}>
                    <>
                        <DialogTitle>Add Managers</DialogTitle>
                        <DialogContent>
                            <Grid container spacing={gridSpacing} sx={{ mt: 0.25 }}>
                                <Grid item xs={12}>
                                    <FormControl fullWidth>
                                        {/* Section 1: Search Existing Manager */}
                                        {/* <Typography variant="h6">Search for Existing Manager</Typography>
                                        <TextField
                                            InputProps={{
                                                startAdornment: (
                                                    <InputAdornment position="start">
                                                        <SearchIcon fontSize="small" sx={{ color: '#462F4D' }} />
                                                    </InputAdornment>
                                                )
                                            }}
                                            sx={{ width: '100%', mb: 2 }}
                                            onChange={(event) => setSearch(event.target.value)}
                                            placeholder="Search Managers by Email"
                                            onBlur={handleBlur}
                                        /> */}

                                        {/* {filteredResults?.length > 0 ? (
                                            <List
                                                sx={{
                                                    width: '100%',
                                                    maxHeight: 500, // Set the maximum height of the list
                                                    overflowY: 'auto', // Make the list scrollable when the content exceeds the height
                                                    mb: 2,
                                                    bgcolor: 'background.paper',
                                                    borderRadius: 2,
                                                    boxShadow: 1
                                                }}
                                            >
                                                {filteredResults?.map((emp) => (
                                                    <ListItem
                                                        key={emp.id}
                                                        button
                                                        onClick={() => setSelectedManager(emp?.id)}
                                                        sx={{
                                                            py: 1.5,
                                                            px: 2,
                                                            my: 0.5,
                                                            borderRadius: 1,
                                                            '&:hover': {
                                                                bgcolor: 'primary.light',
                                                                color: 'black'
                                                            },
                                                            '&.Mui-selected': {
                                                                bgcolor: 'primary.main',
                                                                color: 'white',
                                                                '&:hover': {
                                                                    bgcolor: 'primary.dark'
                                                                }
                                                            }
                                                        }}
                                                        selected={selectedManager === emp?.id}
                                                    >
                                                        <Box>
                                                            <Typography variant="body1" sx={{ fontWeight: 500 }}>
                                                                {emp?.firstName + ' ' + emp?.lastName}
                                                            </Typography>
                                                            <Typography variant="body2" sx={{ color: 'text.secondary' }}>
                                                                {emp?.email}
                                                            </Typography>
                                                        </Box>
                                                    </ListItem>
                                                ))}
                                            </List>
                                        ) : (
                                            search && <Typography>No matches found.</Typography>
                                        )} */}

                                        {/* Divider with "OR" */}
                                        {/* <Divider sx={{ my: 3 }}>
                                            <Typography variant="h6" align="center">
                                                OR
                                            </Typography>
                                        </Divider> */}

                                        {/* Section 2: Invite New Manager */}
                                        <Typography variant="h6">Invite Manager</Typography>
                                        <TextField
                                            value={values?.email}
                                            onChange={handleChange}
                                            name="email"
                                            placeholder="Enter Email to Invite"
                                            fullWidth
                                            sx={{ mb: 2 }}
                                        />
                                        {touched.email && errors.email && <FormHelperText error>{errors.email}</FormHelperText>}
                                    </FormControl>
                                </Grid>
                            </Grid>
                        </DialogContent>
                        <DialogActions>
                            <Box sx={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
                                {/* <Button variant="text" color="secondary" onClick={()=>{
                                    setSelectedManager(null);
                                    setInviteEmail()
                                }}>
                                    Reset
                                </Button> */}
                                <Box />

                                <Box sx={{ display: 'flex', gap: 2, alignItems: 'center' }}>
                                    <AnimateButton>
                                        <LoadingButton
                                            onClick={handleSubmit}
                                            variant="contained"
                                            sx={{
                                                bgcolor: theme.palette.secondary.main,
                                                '&:hover': { bgcolor: theme.palette.secondary.dark }
                                            }}
                                            loading={isSubmitting}
                                        >
                                            {'Add'}
                                        </LoadingButton>
                                    </AnimateButton>
                                    <Button variant="text" color="error" onClick={handleCloseClick}>
                                        Close
                                    </Button>
                                </Box>
                            </Box>
                        </DialogActions>
                    </>
                </form>
            )}
        </Dialog>
    );
};

AddManagers.propTypes = {
    openDialog: PropTypes.bool,
    handleCloseDialog: PropTypes.func
};

export default AddManagers;
